import { render } from "./Course.vue?vue&type=template&id=ae8777da&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=ae8777da&scoped=scoped&lang=less"
import "./Course.vue?vue&type=style&index=1&id=ae8777da&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8777da"]])

export default __exports__